export const GET_BUNDLES = "GET_BUNDLES";
export const GET_BUNDLE_BY_ID = "GET_BUNDLE_BY_ID";
export const UPDATE_BUNDLE = "UPDATE_BUNDLE";
export const DELETE_BUNDLE = "DELETE_BUNDLE";
export const CREATE_BUNDLE = "CREATE_BUNDLE";
